import React from 'react';
import { map, uniq, zipObject, isEmpty } from 'lodash';

const PARAMETER_COLORS = ['#357BFF', '#4AD496', '#9013FE', '#FE1375', '#FED313', '#13FEF2'];

function ParameterizedURLPreview(props) {
  const { parameterizedURLs, urlTemplate } = props;

  if (!parameterizedURLs || isEmpty(parameterizedURLs.urls)) {
    return null;
  }

  const urlTemplateParams = [];
  let placeholderToColorMap = {};

  const { placeholders } = parameterizedURLs;

  for (let i = 0, lastPosition = 0; i < placeholders.length; i++) {
    const placeholder = placeholders[i];
    const startIndex = urlTemplate.indexOf(placeholder, lastPosition);
    const endIndex = startIndex + placeholder.length;
    urlTemplateParams.push({
      placeholder,
      startIndex,
      endIndex,
    });

    lastPosition = endIndex;
  }

  const uniquePlaceholders = uniq(placeholders);
  const numColors = PARAMETER_COLORS.length;
  const colors = map(uniquePlaceholders, (placeholder, i) => PARAMETER_COLORS[i % numColors]);
  placeholderToColorMap = zipObject(uniquePlaceholders, colors);

  return (
    <section className="parameterized-url-preview">
      <h4>Sample URLs:</h4>
      <ul>
        {map(parameterizedURLs.urls, (url, index) => (
          <li key={index}>
            <ParameterizedItem
              url={url.url}
              params={url.params}
              placeholderToColorMap={placeholderToColorMap}
            />
          </li>
        ))}
      </ul>
    </section>
  );
}

function ParameterizedItem(props) {
  const { url, params, isURLTemplate, placeholderToColorMap } = props;
  const slices = [];

  function addSlice(startIndex, endIndex = undefined, placeholder = null) {
    const content = url.slice(startIndex, endIndex);

    if (!content) {
      return;
    }

    let style;
    let className;

    if (placeholder) {
      const color = placeholderToColorMap[placeholder];
      style = isURLTemplate
        ? {
            backgroundColor: `${color}26`,
            border: `1px solid ${color}`,
            borderRadius: 2,
          }
        : {
            color,
          };
      className = 'url-param';
    }

    slices.push(
      <span key={startIndex} className={className} style={style}>
        {content}
      </span>,
    );
  }

  let lastPosition = 0;

  for (let i = 0; i < params.length; i++) {
    const { startIndex, endIndex, placeholder } = params[i];
    addSlice(lastPosition, startIndex);
    addSlice(startIndex, endIndex, placeholder);
    lastPosition = endIndex;
  }

  addSlice(lastPosition);

  return <span>{slices}</span>;
}

export default ParameterizedURLPreview;
